// Analytics event definitions
// These match the event types used in both UI and API

export const AnalyticsEvent = {
  // Client-side events
  PAGE_VIEW: "page_view",
  LISTING_VIEW: "listing_view",
  AVAILABILITY_OPENED: "availability_opened",
  DATE_SELECTED: "date_selected",
  START_CHECKOUT: "start_checkout",
  OPEN_VENDOR_PROFILE: "open_vendor_profile",
  OPEN_CONTACT_VENDOR: "open_contact_vendor",
  SEND_MESSAGE_CLIENT: "send_message_client",
  
  // Server-side events
  BOOKING_CREATED: "booking_created",
  BOOKING_PAID: "booking_paid",
  BOOKING_REFUNDED: "booking_refunded",
  MESSAGE_SENT: "message_sent",
  VENDOR_RESPONSE: "vendor_response",
  LISTING_CREATED: "listing_created",
  LISTING_APPROVED: "listing_approved",
  VENDOR_LOGIN: "vendor_login",
  CUSTOMER_LOGIN: "customer_login",
  BOT_DEFENSE_TRIGGERED: "bot_defense_triggered",
  VENDOR_APPLICATION_SUBMITTED: "vendor_application_submitted",
  VENDOR_SIGNUP: "vendor_signup",
} as const;

export type AnalyticsEventName = typeof AnalyticsEvent[keyof typeof AnalyticsEvent];

